/**
 * mobile-menu.js
 * Handles: mobile slide-in menu open/close and accordion-style
 * sub-menu expand/collapse.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('aria-controls');
      var drawer = document.getElementById(targetId);
      window.PremiumHeader.openDrawer(drawer, btn);
    });
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('[data-mobile-menu]');
      window.PremiumHeader.closeDrawer(drawer);
    });
  });

  document.querySelectorAll('[data-mobile-menu-overlay]').forEach(function (overlay) {
    overlay.addEventListener('click', function () {
      var drawer = overlay.closest('[data-mobile-menu]');
      window.PremiumHeader.closeDrawer(drawer);
    });
  });

  document.querySelectorAll('[data-mobile-accordion-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var panel = toggle.nextElementSibling;

      toggle.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  document.querySelectorAll('[data-mobile-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mobileMenu = btn.closest('[data-mobile-menu]');
      var searchDrawer = document.querySelector('[data-search-sidebar]');
      var searchToggle = document.querySelector('[data-search-toggle]');
      window.PremiumHeader.closeDrawer(mobileMenu);
      window.setTimeout(function () {
        window.PremiumHeader.openDrawer(searchDrawer, searchToggle);
      }, 200);
    });
  });

})();
